'use client';

import { TOAST_NOTIFICATION_ANIMATION_DURATION, TOAST_NOTIFICATION_DISMISSAL_DURATION } from "../../../molecules/ToastNotification/utils/constants.js";
import { MAX_TOAST_NOTIFICATIONS } from "./constants.js";
import { ManagedTimeout } from "./ManagedTimeout.js";
class ToastManager {
  setState = null;
  managedTimeouts = /* @__PURE__ */ new Map();
  toastQueue = [];
  removeToast(id) {
    this.setState?.(
      (prevState) => prevState.map((t) => t.id === id ? { ...t, dismissed: true } : t)
    );
    setTimeout(() => {
      this.managedTimeouts.get(id)?.pause();
      this.managedTimeouts.delete(id);
      this.setState?.(
        (prevState) => (
          // Remove the toast that was marked for dismissal
          prevState.filter((t) => t.id !== id)
        )
      );
    }, TOAST_NOTIFICATION_ANIMATION_DURATION);
  }
  // eslint-disable-next-line class-methods-use-this -- required by ChalkToastManagerContract
  get portalDomNode() {
    if (typeof document !== "undefined") {
      return document.body;
    }
    return null;
  }
  init(setState) {
    if (this.setState === null) {
      this.setState = setState;
    }
  }
  detach() {
    this.pause();
    this.setState = null;
    this.managedTimeouts = /* @__PURE__ */ new Map();
  }
  pause() {
    this.managedTimeouts.forEach((timeout) => timeout.pause());
  }
  resume() {
    this.managedTimeouts.forEach((timeout) => timeout.resume());
  }
  toast(props) {
    const id = `${Date.now()}-${Math.random()}`;
    this.managedTimeouts.set(
      id,
      new ManagedTimeout(
        TOAST_NOTIFICATION_DISMISSAL_DURATION,
        () => this.removeToast(id)
      )
    );
    const newToastNotification = {
      ...props,
      id,
      dismissed: false,
      onDismiss: () => this.removeToast(id)
    };
    this.toastQueue.push(newToastNotification);
    this.onReadyForMore();
  }
  onToastMount(toast2) {
    this.toastQueue = this.toastQueue.filter(
      (queueItem) => !(queueItem.id === toast2.id)
    );
    this.managedTimeouts.get(toast2.id)?.resume();
  }
  onReadyForMore() {
    if (this.toastQueue.length === 0) return;
    const toast2 = this.toastQueue[0];
    this.setState?.((prevState) => {
      if (prevState.length < MAX_TOAST_NOTIFICATIONS) {
        return [...prevState, toast2];
      }
      return prevState;
    });
  }
}
const toastManager = new ToastManager();
const toast = toastManager.toast.bind(toastManager);
export {
  toast,
  toastManager
};
